import { useLang } from '@/i18n';
import EfImg from '@elem/ui/ef-img';
import EfSection from '@elem/ui/ef-section';
import EfSpec from '@elem/ui/ef-spec';
import { useState } from 'react';
import styles from './index.module.scss';


export default function TheComp() {
    const { t } = useLang('delta3series');



    const [activeItem, setActiveItem] = useState({
        pc: 'https://websiteoss.ecoflow.com/upload/image/1775284496939/2-pc.jpg',
        h5: 'https://websiteoss.ecoflow.com/upload/image/1775284497106/2-m.jpg',
        title: t('MX1_title'),
        desc: t('MX1_desc'),
    });



    return (
        <div className={`${styles.TheComp} GtmModuleData-section range2`} data-section-id="D3-MX1" id='D3-MX1'>
            <EfSpec className="spec-x" />
            <EfSection hasAnimation={false} theme="black" title={t.rich('MX_title', {
                sup: (tx: string) => <sup className="sup">{tx}</sup>,
            })} />
            <div className={`box black`}>
                <div className="box-img">
                    <EfImg pc={activeItem.pc} pad={activeItem?.h5} h5={activeItem?.h5 || activeItem.pc} />
                </div>
                <div className="box-msg">
                    <div className="box-title">{activeItem.title}</div>
                    <div className="box-desc">{activeItem.desc}</div>
                </div>
            </div>
            <EfSpec className="spec-x" />
        </div>
    );
}
